import React, { useState } from "react";
import { Link } from "react-router-dom";
import landsData from "../data/lands";
import img from "../images/saudi-arabia.jpg";
import { useLands } from "../context/LandsContext";
import Spinner from "./Shared/Spinner";
const LandsSection = () => {
  const { allLands, isLoading } = useLands();
  const [locationFilter, setLocationFilter] = useState("");
  const [priceFilter, setPriceFilter] = useState("");
  if (isLoading) {
    return <Spinner />;
  }
  console.log(isLoading);
  return (
    <div className="container mt-5" dir="rtl">
      <h2 className="mb-4 text-center fw-bold">الأراضي المتاحة</h2>
      <div className="row justify-content-center mb-5">
        <div className="col-md-4 mb-2">
          <select
            className="form-select shadow-sm"
            onChange={(e) => setLocationFilter(e.target.value)}
          >
            <option value="">كل المناطق</option>
            <option value="الرياض">الرياض</option>
            <option value="جدة">جدة</option>
            <option value="الدمام">الدمام</option>
          </select>
        </div>
        <div className="col-md-4 mb-2">
          <select
            className="form-select shadow-sm"
            onChange={(e) => setPriceFilter(e.target.value)}
          >
            <option value="">كل الأسعار</option>
            <option value="lt100">أقل من 100 ألف</option>
            <option value="100to300">من 100 إلى 300 ألف</option>
            <option value="gt500">أكثر من 500 ألف</option>
          </select>
        </div>
      </div>
      <div className="row">
        {allLands.length > 0 &&
          allLands?.map((land) => (
            <div className="col-md-4 mb-4" key={land.id}>
              <div className="card  h-100 shadow-sm border-0">
                <img
                  src={img}
                  className="card-img-top"
                  alt={land.title}
                  style={{ height: "230px", objectFit: "cover" }}
                />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title fw-bold  mb-4">{land.name}</h5>
                  <div className="mt-auto d-flex justify-content-between">
                    <Link
                      to={`/details/${land.id}`}
                      className="btn btn-outline-primary w-50 me-2"
                    >
                      عرض التفاصيل
                    </Link>
                    <button className="btn btn-success w-50">حجز الأرض</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default LandsSection;
